import React from 'react'

import { OptionsMenu } from '../data-card/data-card-parts'

export default ({
  qaServicing,

  loadPermissions,

  completeQAServicing,
  deleteQAServicing
}) => {
  const actions = []

  if (qaServicing.permissions && qaServicing.permissions.canComplete) {
    actions.push({ name: 'Mark Complete', action: completeQAServicing })
  }

  actions.push({
    name: 'Delete',
    action: deleteQAServicing
  })

  return (
    <OptionsMenu onReveal={loadPermissions} optionItems={actions} />
  )
}



// WEBPACK FOOTER //
// ./src/components/qa-servicings/qa-servicing-options.js